import keyMirror from 'keymirror'

export const DEPOSIT_HISTORY_TYPE = keyMirror({
  confirm: null,
  notifyAccounting: null,
  notifyPM: null,
  allowContractorRefund: null,
  refundRequest: null,
  resumeRefundRequest: null,
  saveDepositAmount: null,
})

export const depositDocTypes = keyMirror({
  cheque: null,
})
